// Bump this when the Terms & Conditions / Privacy Policy content changes.
// Stored alongside each new user so we know who accepted which version.
export const TERMS_VERSION = '2026-01';
